// extracted by mini-css-extract-plugin
export default {"fr-view":"AccountMenu_fr-view__cnyx9","toggle":"AccountMenu_toggle__B-j-C","name":"AccountMenu_name__GVmiW","toggle-icon":"AccountMenu_toggle-icon__t91mn"};